const dateFromApiValue = value => {
  if (!value) return null;
  const numericValue = Number(value);
  let normalizedValue = value;
  if (Number.isFinite(numericValue)) {
    normalizedValue =
      numericValue > 100_000_000_000 ? numericValue : numericValue * 1000;
  }
  const date = new Date(normalizedValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatApiDate = value =>
  dateFromApiValue(value)?.toLocaleDateString() || '';

export const formatApiDateTime = value =>
  dateFromApiValue(value)?.toLocaleString() || '';

export const apiDateTimeValue = value =>
  dateFromApiValue(value)?.toISOString() || undefined;
